const URL = process.env.REACT_APP_FLASK_URL

export const getPlateImages = async (params) => {
    const response = await fetch(`${URL}/get_plates?${params}`)
    if (response.ok) {
        return await response.json()
    } else {
        throw response
    }
}